import { combineReducers } from 'redux';
import currentPage from './next-page-reducer';
import userInfo from './user-info-reducer';
import requestedCommittees from './requested-committees';
import myCommittees from './my-committees';
import passwordError from './password-error-reducer';
import isLoading from './loading-reducer';
import token from './token-reducer';
import committeeLoading from './loading-committee-reducer';
import allStates from './set-states-reducer';

export default combineReducers( {
	                                currentPage,
	                                userInfo,
	                                myCommittees,
	                                requestedCommittees,
	                                passwordError,
	                                isLoading,
	                                token,
	                                committeeLoading,
	                                allStates
                                } );